module.exports = __webpack_public_path__ + "audio-bdb8c12e902d.m4a";